import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'phx-summary-row',
  styleUrls: ['./phx-summary-row.scss'],
  templateUrl: './phx-summary-row.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-summary-row',
  },
})
export class PhxSummaryRowComponent  {
  @Input() public phxLoading: boolean = false;
}
